import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import PromoCodeManager from '@/components/v2/PromoCodeManager.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import GraphqlErrorMixin from '@/helpers/vue_mixins/GraphqlErrorMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import DiyMixin from '@/helpers/vue_mixins/v2/DiyMixin';
import { validationMixin } from 'vuelidate';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { Getter } from 'vuex-class';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
import BusinessAccountDetails from '@/plugins/graphql/queries/v2/business-account-details.gql';
import MetaAdSetting from '@/plugins/graphql/queries/v2/meta-ad-settings.gql';
import { AppBasicModel } from '@/helpers/entities/models/AppBasicModel';
import FbBusinessLoginButton from '@/components/auth/FbBusinessLoginButton.vue';
let MetaAdSettings = class MetaAdSettings extends Mixins(ViewportSizeMixin, AlertMixin, ButtonLoaderMixin, GraphqlErrorMixin, Mixins(RouterParamsAppMixin, CleverTapEventsMixin, DiyMixin, validationMixin)) {
    constructor() {
        super(...arguments);
        this.isBusinessLoggedIn = false;
        this.form = {
            appUuid: null,
            generalAdsPostbackPayload: null,
        };
    }
    copyPayloadToClipboard() {
        const self = this;
        const text = this.form.generalAdsPostbackPayload;
        if (text) {
            const input = document.createElement('input');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            self.successNotification('Successfully Copied to Clipboard!');
        }
    }
    refetchBusinessDetails() {
        this.$apollo.queries.businessAccountDetails.refetch();
    }
    hideBusinessDetails() {
        this.isBusinessLoggedIn = false;
    }
    get isInsuranceBundle() {
        return this.$route.params.key === Bundle.Insurance;
    }
};
__decorate([
    Getter('requestOnFlight')
], MetaAdSettings.prototype, "requestCurrentlyOnFlight", void 0);
MetaAdSettings = __decorate([
    Component({
        components: {
            BaseTextField,
            PageTitle,
            PromoCodeManager,
            ActionButton,
            AppBasicDetails,
            BaseOverlayLoader,
            FbBusinessLoginButton,
        },
        apollo: {
            app: {
                query: MetaAdSetting,
                variables() {
                    return { appUuid: this.appUUID };
                },
                update(data) {
                    this.form.appUuid = new AppBasicModel(data.app).uuid;
                    const generalAds = new AppBasicModel(data.app).generalAdsPostbackPayload;
                    this.form.generalAdsPostbackPayload = generalAds;
                    return new AppBasicModel(data.app);
                },
                fetchPolicy: 'network-only',
            },
            businessAccountDetails: {
                query: BusinessAccountDetails,
                variables() {
                    return { appUuid: this.appUUID };
                },
                update(data) {
                    const details = data.businessAccountDetails;
                    if (details) {
                        this.businessPortfolio = details.businessPortfolio;
                        this.pixelName = details.pixelName;
                        this.pixelId = details.pixelId;
                        this.pages = details.pages;
                        this.adAccounts = details.adAccounts;
                        if (this.businessPortfolio) {
                            this.isBusinessLoggedIn = true;
                        }
                    }
                },
                fetchPolicy: 'network-only',
            },
        },
    })
], MetaAdSettings);
export default MetaAdSettings;
